// src/components/RoleMenu.jsx

import { getUser } from "./AuthService";

function RoleMenu() {
  const user = getUser();

  if (user?.role === "admin-IT") {
    return (
      <div className="dash-access" role="status">
        <i className="bi bi-shield-check" aria-hidden="true" />
        Admin Panel Access
      </div>
    );
  }

  if (user?.role === "employee") {
    return (
      <div className="dash-access employee" role="status">
        <i className="bi bi-person-badge" aria-hidden="true" />
        Employee Dashboard
      </div>
    );
  }

  return null;
}

export default RoleMenu;
